<div class="sidebar-detail">
  <div class="sidebar-panel">
    <div class="task-detail-group sidebar-content">
      @if (!isTransactionTask()) {
        <div class="panel-title">
          {{ task?.title || 'Task Details' }}
          <button class="close-icon" (click)="onClose()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }

      <!-- Task-specific detail components -->
      @if (isMerchantTask()) {
        <app-merchant-change-detail
          [taskId]="task?.id"
          [detail]="getMerchantDetail()"
          [initiatedBy]="getTaskInitiatedBy()"
          [canResolve]="canResolveTask()"
          [preparedDate]="task?.createdDate"
          [isHistory]="isTaskHistory()"
          [resolution]="getTaskResolution()"
          [status]="getStatusText()"
          [resolvedBy]="getTaskResolvedBy()"
          [resolvedAt]="getTaskResolutionDate()"
          [comment]="task?.comment"
          [hideHeader]="true"
          (closed)="onClose()"
          (refresh)="onTaskRefresh()"
        />
      }
      @if (isWhitelistTask() && getWhitelistDetail()) {
        <app-merchant-whitelisted-wallet-details
          [wallet]="getWhitelistDetail()!"
          [isTaskContext]="true"
          [showActions]="!isTaskHistory()"
          (closed)="onClose()"
          (refresh)="onTaskRefresh()"
        />
      }
      @if (isRiskTask()) {
        <app-risk-alert-detail
          [detail]="getRiskDetail()"
          [initiatedBy]="getTaskField('initiatedByDisplayName')"
          [preparedDate]="task?.createdDate"
          [isHistory]="isTaskHistory()"
          [resolution]="getTaskResolution()"
          [resolvedBy]="getTaskResolvedBy()"
          [resolvedAt]="getTaskResolutionDate()"
          [comment]="task?.comment"
          [taskId]="task?.id"
          [isAcknowledgeOnly]="!!task?.isAcknowledgeOnly"
          [taskType]="task?.type"
          (closed)="onClose()"
          (refresh)="onTaskRefresh()"
        />
      }
      @if (isPreLaunchEvmTask()) {
        <app-pre-launch-evm-detail
          [detail]="getPreLaunchEvmDetail()"
          [description]="getTaskDescription()"
          [preparedBy]="getTaskField('initiatedByDisplayName')"
          [createdDate]="task?.createdDate"
          [isHistory]="isTaskHistory()"
          [resolvedBy]="getTaskResolvedBy()"
          [resolvedAt]="getTaskResolutionDate()"
          [status]="getStatusText()"
          [comment]="task?.comment"
          [taskId]="task?.id"
          [relatedTransactionId]="task?.relatedTransactionId"
          (closed)="onClose()"
          (refresh)="onTaskRefresh()"
        />
      }
      @if (isTransactionTask() && getWithdrawalAsTransaction()) {
        <app-transaction-details
          [transaction]="getWithdrawalAsTransaction()!"
          [taskId]="isTaskHistory() ? undefined : task?.id"
          [isAcknowledgeOnly]="!isExchangeRateRequiredTask() && !!task?.isAcknowledgeOnly"
          [hideHeader]="true"
          (closed)="onClose()"
          (transactionUpdated)="onTaskRefresh()"
        />
      }

      <!-- Generic task details for other task types -->
      @if (!isMerchantTask() && !isWhitelistTask() && !isRiskTask() && !isTransactionTask() && !isPreLaunchEvmTask()) {
        <div class="generic-task-details">
          <div class="detail-row">
            <div class="field-label">Description</div>
            <div class="field-value description-value">{{ getTaskDescription() }}</div>
          </div>
          <div class="detail-row">
            <div class="field-label">Prepared by</div>
            <div class="field-value">{{ getTaskField('initiatedByDisplayName') || 'N/A' }}</div>
          </div>

          @if (isDelegationTask() && getDelegationDetail(); as detail) {
            @if (detail.merchantName) {
              <div class="detail-row">
                <div class="field-label">Merchant</div>
                <div class="field-value">{{ detail.merchantName }}</div>
              </div>
            }
            @if (detail.networkName) {
              <div class="detail-row">
                <div class="field-label">Network</div>
                <div class="field-value">{{ detail.networkName }}</div>
              </div>
            }
            @if (getRiskGroupLabel(); as riskGroupLabel) {
              <div class="detail-row">
                <div class="field-label">Risk group</div>
                <div class="field-value">{{ riskGroupLabel }}</div>
              </div>
            }
            <div class="detail-row">
              <div class="field-label">Resource</div>
              <div class="field-value">{{ getResourceTypeLabel() }}</div>
            </div>
            @if (detail.configuredInResourceUnits != null) {
              <div class="detail-row">
                <div class="field-label">Configured</div>
                <div class="field-value">{{ detail.configuredInResourceUnits | number }}</div>
              </div>
            }
            @if (detail.heldInResourceUnits != null) {
              <div class="detail-row">
                <div class="field-label">Held</div>
                <div class="field-value">{{ detail.heldInResourceUnits | number }}</div>
              </div>
            }
            @if (detail.topUpInResourceUnits != null) {
              <div class="detail-row">
                <div class="field-label">Top-up</div>
                <div class="field-value">{{ detail.topUpInResourceUnits | number }}</div>
              </div>
            }
            @if (detail.fundedFromPotInResourceUnits != null) {
              <div class="detail-row">
                <div class="field-label">Funded from pot</div>
                <div class="field-value">{{ detail.fundedFromPotInResourceUnits | number }}</div>
              </div>
            }
            @if (detail.fundedFromReserveInResourceUnits != null) {
              <div class="detail-row">
                <div class="field-label">Funded from Reserve</div>
                <div class="field-value">{{ detail.fundedFromReserveInResourceUnits | number }}</div>
              </div>
            }
            @if (detail.shortfallInResourceUnits != null) {
              <div class="detail-row">
                <div class="field-label">Shortfall</div>
                <div class="field-value">{{ detail.shortfallInResourceUnits | number }}</div>
              </div>
            }
          }

          @if (isTaskHistory()) {
            <div class="detail-row">
              <div class="field-label">Resolved by</div>
              <div class="field-value">{{ getTaskResolvedBy() || 'N/A' }}</div>
            </div>
            <div class="detail-row">
              <div class="field-label">Resolved at</div>
              <div class="field-value">{{ getResolvedAtText() }}</div>
            </div>
          } @else {
            <div class="detail-row">
              <div class="field-label">Date</div>
              <div class="field-value">{{ getTaskDate() }}</div>
            </div>
          }
          @if (getTaskAttachments().length > 0) {
            <div class="detail-row">
              <div class="field-label">Attachments</div>
              <div class="field-value">
                @for (attachment of getTaskAttachments(); track $index) {
                  <div class="attachment">
                    <mat-icon>attach_file</mat-icon>
                    <span>{{ attachment.fileName }}</span>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

      <!-- Status and comments only for non-specific task types -->
      @if (!isMerchantTask() && !isWhitelistTask() && !isRiskTask() && !isTransactionTask() && !isPreLaunchEvmTask()) {
        <div>
          <div class="detail-row">
            <div class="field-label">Status</div>
            <div class="field-value">
              <div class="status-badge" [ngClass]="getStatusClass()">
                <mat-icon class="status-icon">
                  {{ getStatusIcon() }}
                </mat-icon>

                <div class="badge-text">{{ getBadgeText() }}</div>
              </div>
            </div>
          </div>

          @if (isTaskHistory()) {
            <div class="comments-heading">Comments</div>
            <textarea class="comment-box" aria-label="Comments" readonly placeholder="No comment">{{
              task?.comment
            }}</textarea>
          }
        </div>
      }
    </div>

    @if (errorMessage || hasActions()) {
      <div class="sidebar-actions">
        @if (errorMessage) {
          <div class="error-message" role="alert">
            <mat-icon class="error-icon">error</mat-icon>
            {{ errorMessage }}
          </div>
        }

        @if (hasActions()) {
          <div class="comments-heading">Comments</div>
          <textarea
            class="comment-box"
            aria-label="Comments"
            [(ngModel)]="comment"
            placeholder="Enter your comment"
          ></textarea>

          <div class="button-group">
            @if (task?.isAcknowledgeOnly) {
              <app-button
                buttonVariant="primary"
                buttonType="button"
                [state]="processingButtonState"
                (buttonClick)="onAcknowledge()"
              >
                {{ resolving ? 'Processing...' : 'Acknowledge' }}
              </app-button>
            } @else {
              <app-button
                buttonVariant="primary"
                buttonType="button"
                [state]="processingButtonState"
                (buttonClick)="onApprove()"
              >
                {{ resolving ? 'Processing...' : 'Approve' }}
              </app-button>
              <app-button
                buttonVariant="sidebar-danger"
                buttonType="button"
                [state]="processingButtonState"
                (buttonClick)="onReject()"
              >
                {{ resolving ? 'Processing...' : 'Reject' }}
              </app-button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
